import { HttpEventType } from '@angular/common/http';
import { Component } from '@angular/core';
import { DigitalesService } from '../../../../../shared/services/digitales.service';
import { Administracion } from '../../../../../shared/model/administracion.model';
import { ActivatedRoute } from '@angular/router';
import { AdministracionService } from '../../../../../shared/services/administracion.services';

@Component({
  selector: 'app-digitales-empresas',
  templateUrl: './digitales-empresas.component.html',
  styleUrls: ['./digitales-empresas.component.scss']
})
export class DigitalesEmpresasComponent {
  archivos: any[] = [];
  imagenGrande: string | null = null;
  zoom: number = 1;
  nit: string | null = null; // Variable global (propiedad del componente)
  administraciones: Administracion[] = [];
  constructor(private digitalesService: DigitalesService, private route: ActivatedRoute, private administracionesServices: AdministracionService,) { }

  ngOnInit() {
    this.archivos = [
      { id: 1, nombre: 'RUT', file: null, prefijo: 'RUT', formatos: ['pdf'] },
      { id: 2, nombre: 'CAMARA DE COMERCIO', file: null, prefijo: 'CDC', formatos: ['pdf'] },
      { id: 3, nombre: 'CEDULA REPRESENTANTE LEGAL FRONTAL', file: null, prefijo: 'CR1', formatos: ['jpg', 'jpeg', 'png'] },
      { id: 4, nombre: 'CEDULA REPRESENTANTE LEGAL POSTERIOR', file: null, prefijo: 'CR2', formatos: ['jpg', 'jpeg', 'png'] },
    ];

    this.cargarDataAdmin();

    this.route.paramMap.subscribe(params => {
      this.nit = params.get('nit')!;
     // console.log('ID recibido:', this.nit);

    });
  }

  isImage(file: File): boolean {
    const imageTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    return imageTypes.includes(file.type);
  }

  private cargarDataAdmin(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {
     //   console.log(data);
        this.administraciones = data;


      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
  }

  onFileChange(event: any, id: number) {
    const file = event.target.files[0];
    const archivo = this.archivos.find(a => a.id === id);

    if (file && archivo) {
      const extension = file.name.split('.').pop().toLowerCase();
      const formatosPermitidos = archivo.formatos || [];

      if (!formatosPermitidos.includes(extension)) {
        archivo.estado = 'error';
        archivo.mensaje = `Formato no permitido. Se permiten: ${formatosPermitidos.join(', ')}`;
        archivo.file = null;
        return;
      }

      archivo.estado = '';
      archivo.mensaje = '';

      if (['jpg', 'jpeg', 'png'].includes(extension)) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          archivo.file = { file, preview: e.target.result };
        };
        reader.readAsDataURL(file);
      } else {
        // Para PDFs u otros formatos, no hay preview imagen
        archivo.file = { file, preview: '' };
      }
    }
  }

  // Cambiar estilo al arrastrar el archivo
  onDragOver(event: DragEvent) {
    event.preventDefault(); // necesario para permitir drop
    const target = event.currentTarget as HTMLElement;
    target.classList.add('drag-over');
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove('drag-over');
  }

  // Cuando sueltas el archivo en la zona
  onDrop(event: DragEvent, id: number) {
    event.preventDefault();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove('drag-over');

    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];

      // Validar formato si quieres, con archivo.acceptedFormats

      // Crear objeto FileReader para generar preview
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const archivo = this.archivos.find(a => a.id === id);
        if (archivo) {
          archivo.file = { file, preview: e.target.result };
        }
      };
      reader.readAsDataURL(file);

      event.dataTransfer.clearData();
    }
  }
  subirArchivo(id: number, nombreCarpeta: string, prefijo: string) {
    const archivo = this.archivos.find(a => a.id === id);
    if (!archivo || !archivo.file) return;

    archivo.estado = 'Subiendo';
    archivo.progreso = 0;
    nombreCarpeta = this.administraciones[0].nit + "/" + nombreCarpeta;
    this.digitalesService.subirArchivo(archivo.file.file, id, nombreCarpeta, this.nit!, prefijo)
      .pipe(
      // Cambia la llamada para que retorne eventos (HttpEvent)
      // Esto requiere que el servicio 'subirArchivo' use { reportProgress: true, observe: 'events' }
    )
      .subscribe({
        next: (event) => {
          console.log(event);
          if (event.type === HttpEventType.UploadProgress && event.total) {
            archivo.progreso = Math.round(100 * event.loaded / event.total);
          } else if (event.type === HttpEventType.Response) {
            archivo.estado = 'exito';
            archivo.mensaje = `Archivo ${id} subido con éxito`;
          }
        },
        error: (error) => {
          archivo.estado = 'error';
          archivo.mensaje = `Error al subir el archivo ${id}`;
          console.error(archivo.mensaje, error);
        }
      });
  }


  removeFile(id: number) {
    const archivo = this.archivos.find(a => a.id === id);
    if (archivo) {
      archivo.file = null;
    }
  }

  verImagenCompleta(preview: string) {
    this.imagenGrande = preview;
    this.zoom = 1;
  }

  cerrarImagenCompleta() {
    this.imagenGrande = null;
  }

  hacerZoom(event: WheelEvent) {
    event.preventDefault();
    this.zoom += event.deltaY * -0.01;
    this.zoom = Math.min(Math.max(1, this.zoom), 3);
    const img = event.target as HTMLImageElement;
    img.style.transform = `scale(${this.zoom})`;
  }


}
